const safeAdd = (...numbers: Array<number | undefined | null>): number => {
  return numbers.map((num) => num ?? 0).reduce((sum, num) => sum + num, 0);
};

const safeSubtract = (...args: Array<number | undefined | null>): number => {
  const numbers = args.map((arg) => arg ?? 0);
  return numbers.reduce((result, num, index) =>
    index === 0 ? num : result - num
  );
};

const safeMultiply = (
  a: number | undefined,
  b: number | undefined
): number | undefined => {
  return a != null && b != null ? a * b : undefined;
};

const safeDivide = (
  numerator: number | undefined,
  denominator: number | undefined
): number | undefined => {
  if (numerator == null || denominator == null) return undefined;
  if (denominator === 0) return undefined;
  return numerator / denominator;
};

const safePercentage = (
  numerator: number | undefined,
  denominator: number | undefined
): number | undefined => {
  const divided = safeDivide(numerator, denominator);
  return divided != null ? Math.round(divided * 100) : undefined;
};

export { safeAdd, safeDivide, safeMultiply, safePercentage, safeSubtract };
